import i18n from 'i18next';
import Backend from 'i18next-http-backend';

// eslint-disable-next-line no-undef
console.log(`YSS_LANG_URL=${YSS_LANG_URL}`);

export const LANG_STORAGE_KEY = 'sapphire_organizer_lang';
export const DEFAULT_LANGUAGE = 'zh_tw';
export const SUPPORTED_LANGUAGES = ['zh_tw', 'zh_cn', 'en', 'ja', 'ko'];

export const getInitialLanguage = () => {
	if (typeof window === 'undefined') {
		return DEFAULT_LANGUAGE;
	}

	const savedLanguage = window.localStorage.getItem(LANG_STORAGE_KEY);
	return SUPPORTED_LANGUAGES.includes(savedLanguage)
		? savedLanguage
		: DEFAULT_LANGUAGE;
};

i18n
	.use(Backend)
	.init({
		lng: getInitialLanguage(),
		fallbackLng: DEFAULT_LANGUAGE,
		supportedLngs: SUPPORTED_LANGUAGES,
		backend: {
			loadPath:
				`/locales/{{lng}}.json?random=` +
				new Date().getTime() +
				Math.floor(Math.random() * 1000000),
		},
		ns: ['locales'],
		defaultNS: 'locales',
		globalInjection: true,
		debug: false,
	});

export default i18n;
